module.exports = __webpack_public_path__ + "static/media/bv.d27dd8f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bv.svg
// module id = 75
// module chunks = 0